import React from 'react';
import PropTypes from 'prop-types';
import { Drawer } from 'antd';

const RDPanel = ({
  panelTitle,
  panelPlacement,
  onClosePanel,
  isVisiblePanel,
  children,
  panelFooter,
  panelWidth,
}) => (
  <Drawer
    title={panelTitle}
    placement={panelPlacement}
    onClose={onClosePanel}
    visible={isVisiblePanel}
    footer={panelFooter}
    width={panelWidth}
  >
    {children}
  </Drawer>
);

RDPanel.defaultProps = {
  panelTitle: '',
  panelPlacement: 'right',
  panelWidth: '25vw',
  onClosePanel: () => {},
  panelFooter: undefined,
  isVisiblePanel: false,
};

RDPanel.propTypes = {
  /** Panel title */
  panelTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** The placement of the Panel */
  panelPlacement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  /** Specify a callback that will be called when a user clicks mask, close button */
  onClosePanel: PropTypes.func,
  /** Whether the Panel is visible or not */
  isVisiblePanel: PropTypes.bool,
  /** Panel Content */
  children: PropTypes.element.isRequired,
  /** The footer for Panel */
  panelFooter: PropTypes.element,
  /** Width of the Panel */
  panelWidth: PropTypes.string,
};

export default RDPanel;
